import { Link, useSearchParams } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function Login() {
  const [params] = useSearchParams();
  const next = params.get("next") || "/";

  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    // Stash the post-login redirect target so AuthCallback can pick it up
    try { sessionStorage.setItem("post_login_next", next); } catch (e) { console.warn("sessionStorage unavailable:", e); }
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      {/* Left visual */}
      <div className="hidden lg:flex bg-[#FFFFFF] border-r border-[#E5E1D8] p-12 flex-col justify-between grid-bg">
        <div>
          <div className="brand-tag">[ AUTH / 001 ]</div>
          <h1 className="font-display text-6xl uppercase tracking-tighter leading-[0.9] mt-4">
            Identify<br />
            <span className="text-outline">Yourself.</span>
          </h1>
          <p className="mt-6 max-w-md text-[#6E6E6E]">
            Sign in to lock your spot in tonight&apos;s drop. The lower the count when you join, the lower your price.
          </p>
        </div>
        <div className="font-mono-ds text-xs text-[#6E6E6E] uppercase tracking-widest">
          // Drop Shop Live — 9PM Daily
        </div>
      </div>

      {/* Right form */}
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <div className="brand-tag mb-4">// Sign In</div>
          <h2 className="font-display text-4xl uppercase tracking-tight">Enter The Drop</h2>
          <p className="mt-2 text-[#6E6E6E] text-sm">One click — Google handles the rest.</p>

          <Button
            onClick={handleGoogle}
            className="mt-8 w-full rounded-2xl bg-[#FFFFFF] text-[#161616] hover:bg-[#FF6A00] hover:text-[#161616] font-mono-ds uppercase tracking-widest h-12 flex items-center justify-center gap-3"
            data-testid="google-signin-btn"
          >
            <svg width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A10.99 10.99 0 0 0 12 23z"/><path fill="currentColor" d="M5.84 14.09a6.61 6.61 0 0 1 0-4.18V7.07H2.18a10.99 10.99 0 0 0 0 9.86l3.66-2.84z"/><path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/></svg>
            Continue with Google
          </Button>

          {next.startsWith("/live/") && (
            <div className="mt-4 border border-[#E5E1D8] bg-[#FFFFFF] p-3" data-testid="live-gate-hint">
              <div className="brand-tag mb-1">// First-time Setup</div>
              <p className="text-[#6E6E6E] text-xs leading-relaxed">
                New here? After sign-in we&apos;ll ask for a shipping address (≈30 sec) so you can buy the moment the price hits its floor during the live. Returning members go straight into the drop.
              </p>
            </div>
          )}

          <Link to="/" className="mt-8 block text-center font-mono-ds text-xs uppercase tracking-[0.3em] text-[#6E6E6E] hover:text-[#FF6A00]" data-testid="back-home-link">
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
